import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';

import { AngularFileUploadComponent } from './file-upload.component'
import { ComboInputModule } from '../combo-input/combo-input.module';

@NgModule({
    imports: [FileUploadModule, CommonModule],
    declarations: [AngularFileUploadComponent],
    exports: [AngularFileUploadComponent],
    providers: []
})
export class AngularFileUploadModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/file-upload/file-upload.module.ts